import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import renderHTML from 'react-render-html';
import { Fade } from 'react-reveal';
import { Actions } from '../../flux';
import { images, texts, urls } from '../../settings';
import { DelayLink } from '../../components';
import EventosList from '../../static/json/Eventos.json';

import './Eventos.scss';

class Eventos extends Component {
  constructor(props) {
    super(props);

    this.state = {
      width: window.innerWidth,
      eventActive: 0
    };

    this.texts = texts;

    this.contentText = React.createRef();
  }

  scrollTop = () => {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  }

  componentDidMount = () => {
    Actions.headerIntern();
    this.scrollTop();
	}
	
	changeItem = index => {
    const { eventActive } = this.state
    
		if (index >= 0 && index < EventosList.length) {
      let events = EventosList[eventActive];

			this.setState({
        eventActive: index
			})
		}
	}

  render = () => {
		const { eventActive } = this.state
		let events = EventosList[eventActive];

    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>Eventos - {this.texts.title}</title>
        </Helmet>

        <div className="parallax-image">
          <img src={images.eventos.bg} />
        </div>

        <div className="eventos-page" ref="eventos">
          <section className="eventos-area page--green">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <div className="card card--page-body card--green">
                      <div className="card__content">
                        <div className="card__content__header gri_text">
                          <h1 className="title">Eventos</h1>
													<span className="gri_label">GRI <b>103-1, 103-2, 103-3, 203-2</b></span>
                        </div>
                        <div className="card__content__body">
                          <p>Realizamos 16 encontros presenciais e online para falar sobre temas em alta no mercado e de interesse dos associados.</p>
													<p>Durante o ano, mais de 4.700 pessoas participaram de seminários, debates, webinars e workshops que trataram desde educação financeira até regulação, passando por investimentos, inovação e tecnologia. Saiba mais sobre eles abaixo.</p>
                        </div>
                      </div>
                      <div className="card__image">
                        <img src={images.eventos.topo} />
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>

          <div className="compromissos-area-container">

            <section className="compromissos-area">
              <div className="container">
                <div className="row">
                  <div className="col-12">

										<Fade bottom>
											<div className="congresso_header">
												<h2>{events[0].topic}</h2>

												<div className="congresso_header__nav">
													<div className={`c__nav__button c__nav__button--prev ${eventActive <= 0 ? 'disabled' : ''}`} onClick={() => this.changeItem(eventActive-1)}></div>
													<div className="c__nav__status">
														<b>{eventActive + 1}</b>/{EventosList.length}
													</div>
													<div className={`c__nav__button c__nav__button--next ${eventActive+1 > (EventosList.length-1) ? 'disabled' : ''}`} onClick={() => this.changeItem(eventActive+1)}></div>
												</div>

											</div>
										</Fade>

										<Fade bottom>
											<div className="congresso_body">
												<div className="congresso_body__content">
													
													{events.map((item, index) => {
														return (
															<div className={`congresso_body__content__item congresso_body__content__item--${eventActive} ${(item.autoHeight) ? `congresso_body__content__item--auto-height` : ``}`} key={index}>
																<div className="item__text">
																	<header>
																		<h3 className="title">{renderHTML(item.title)}</h3>
																		<h4 className="subtitle">{renderHTML(item.subtitle)}</h4>
																	</header>
																	<section>
																		<div>
																			<p className="text">
																				{renderHTML(item.text)}
																			</p>

																			{
																				item.buttonText && item.buttonLink && !item.buttonLink.includes('http') &&
																				<DelayLink
																					to={item.buttonLink}
																					className="button button--aylen button--gray-500 button--border-medium button--size-m button--round-l button--text-thick"
																				>
																					{item.buttonText}
																				</DelayLink>
																			}

																			{
																				item.buttonText && item.buttonLink && item.buttonLink.includes('http') &&
																				<a
                                          href={item.buttonLink}
                                          target="_blank"
																					className="button button--aylen button--gray-500 button--border-medium button--size-m button--round-l button--text-thick"
																				>
																					{item.buttonText}
																				</a>
																			}
																		</div>

																		{ item.list && <ul>
																			{item.list.map((li, i) => (
																				<li key={i}>
																					<span className="icon"><img src={`${urls.assets}img/eventos/${li.icon}`} /></span>
																					<span><b>{li.bold}</b> {li.text}</span>
																				</li>
																			))}
																		</ul> }
																	</section>
																</div>

																{
																	item.image && 
																	<div className="item__image">
																		<img src={`${urls.assets}img/eventos/${item.image}`} />
																	</div>
																}
															</div>
														)
													})}

												</div>
											</div>
										</Fade>

                  </div>
                </div>
              </div>
            </section>
						
          </div>

          <section className="perfil-associados-area page--green">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade>
                    <div className="box-pill box-pill--blue box-pill--center">
                      <div className="box-pill__content box-pill__content--full">
                        <div className="row">
                          <div className="col col-9 col--text">
                            <h4>Veja as principais iniciativas que desenvolvemos em 2019</h4>
                            <DelayLink
                              to="/estrategias/nosso-ano"
                              className="button button--aylen button--white-to-blue button--border-medium button--size-m button--round-l button--text-thick"
                            >
                              Saiba mais
                            </DelayLink>
                          </div>
                          <div className="col col-3">
                            <img src={images.eventos.pessoa} className="pessoa_destaque pessoa_destaque--1" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  }
}

export { Eventos };
